import Phaser from 'phaser';
import { appConfig } from '@config/app.config';
import { BootScene } from '@scenes/BootScene';
import { MainMenuScene } from '@scenes/MainMenuScene';
import { GameplayScene } from '@scenes/GameplayScene';
import { GameOverScene } from '@scenes/GameOverScene';

function createGame(): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'game-container',
    width: appConfig.gameWidth,
    height: appConfig.gameHeight,
    backgroundColor: '#0f1115',
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: [BootScene, MainMenuScene, GameplayScene, GameOverScene],
    fps: {
      target: appConfig.targetFps,
      forceSetTimeOut: false,
    },
    render: {
      antialias: true,
      pixelArt: false,
      roundPixels: true,
    },
    input: {
      activePointers: 1,
    },
  });
}

const game = createGame();

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    game.destroy(true);
  });
}

export default game;
